//메드몰은 무엇인가요 링크, 소개링크
export const detail_introduction =
"https://redandblue.notion.site/MEDMall-1cb2e6d1d57c495fb07808dd000eed61";
//알림
export const notice_site =
  "https://redandblue.notion.site/abd6e93ea54a4323b933f2f7b4af586f";
// kobama site link
export const siteLink_kobama = "https://www.kobama.or.kr/";

//medmall_logo img
export const medmall_logo = "/img/medmall_org_logo.jpg";
export const logo_symbol = "/img/logo_symbol.png";
//intro img
export const medmall_header = "/img/medmall_header.png";
export const medmall_Introduction1 = "/img/001.png";
export const medmall_Introduction2 = "/img/002.png";
export const medmall_Introduction3 = "/img/003.png";
export const medmall_Introduction4 = "/img/004.png";
export const medmall_Introduction5 = "/img/005.png";
export const medmall_Introduction6 = "/img/006.png";
export const medmall_Introduction7 = "/img/007.png";
export const medmall_Introduction8 = "/img/008.png";
export const medmall_Introduction9 = "/img/009.png";
export const medmall_Introduction10 = "/img/010.png";
export const medmall_Introduction11 = "/img/011.png";

export const home_1 = "/img/home1.png";
export const home_2 = "/img/home2.png";
export const home_3 = "/img/home3.png";

export const home_1m = "/img/home1m.png";
export const home_2m = "/img/home2m.png";
export const home_3m = "/img/home3m.png";

